import React from 'react'
import '../css/Loading.css';

const Loading = (props) => {
  return (
    <div className='container' style={{marginTop:"320px"}}>
      {/* <div class="loader" style={{margin:"auto"}}></div> */}
      <div class="loader3">
  <div class="bars bar1"></div>
  <div class="bars bar2"></div>
  <div class="bars bar3"></div>
  <div class="bars bar4"></div>
  <div class="bars bar5"></div>
  <div class="bars bar6"></div>
  <div class="bars bar7"></div>
  <div class="bars bar8"></div>
  <div class="bars bar9"></div>
  <div class="bars bar10"></div>

</div>
  <p className='text-center mt-3'>{props.text}</p>
      </div>
  )
}

export default Loading
